import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Default.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Index,
    children: [
      {
        name: 'share',
        path: "/show/:showItems",
      },
      {
        name: 'sharePart',
        path: "/showAll/:showItems",
      },
      {
        name: 'internalLink',
        path: "/searchbyversion/:version",
      },
      {
        name: 'definitionLink',
        path: "/definitions/:definition",
      },
      {
        name: 'tagLink',
        path: "/tags/:tag",
      }
    ]
   },
  {
    name: 'searchPrint',
    path: "/search-print/:contentId",
    component: () => import("@/views/PrintPreview.vue"), 
    props: route => ({ idlist: route.params.contentId})
  },
  {
    path :'*',
    component:NotFound
  }
]

const router = new VueRouter({
  
  base: process.env.BASE_URL,
  routes
})

export default router
